import m from "../../geodata/es2015/ecuadorLow";
window.am4geodata_ecuadorLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/ecuadorLow.js
// module id = null
// module chunks = 